import React from 'react';

interface ErrorMessageProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  title = 'Error', 
  message, 
  onRetry 
}) => {
  return (
    <div className="bg-red-50 border border-red-200 text-red-800 rounded-md p-4">
      <h3 className="text-lg font-medium">{title}</h3>
      <p className="mt-1">{message}</p>
      
      {onRetry && (
        <button 
          onClick={onRetry} 
          className="mt-3 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;